import {RiseOutlined} from "@ant-design/icons";

import DataMediumBlock from "../../containers/DataMediumBlock";

import styles from "./data-card.module.scss";

const DataCard = ({title, total, percent, period}) => {
    const totalSum = isFinite(total) ? total : 0;

    return (
        <DataMediumBlock>
            <p className={styles.title}>{title}</p>
            <p className={styles.total}>{totalSum}</p>
            {percent && <div className={styles.percentWrapper}>
                <RiseOutlined className={styles.percentIcon} />
                <span className={styles.percent}>{`${percent}%`}</span>
                <span className={styles.period}>{period}</span>
            </div>}
        </DataMediumBlock>
    )
}

export default DataCard;
